import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import '../../../assets/css/City/AddCity.css'; // Custom styles
const API_BASE_URL = process.env.REACT_APP_API_URL;
const AddCity = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: '',
    code: '',
    country: '',
    state: '',
    remarks: '',
    status: true,
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  // Fetch countries and states
  const fetchInitialData = useCallback(async () => {
    try {
      const [countriesRes, statesRes] = await Promise.all([
        axios.get(`${API_BASE_URL}/api/countries`),
        axios.get(`${API_BASE_URL}/api/states`),
      ]);
      setCountries(countriesRes.data);
      setStates(statesRes.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }, []);

  // If editing, fetch city details
  const fetchCity = useCallback(async () => {
    if (id) {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/cities/${id}`);
        const city = res.data;
        setForm({
          name: city.name || '',
          code: city.code || '',
          country: city.country?._id || '',
          state: city.state?._id || '',
          remarks: city.remarks || '',
          status: city.status ?? true,
        });
      } catch (error) {
        console.error('Error fetching city:', error);
      }
    }
  }, [id]);

  useEffect(() => {
    fetchInitialData();
    fetchCity();
  }, [fetchInitialData, fetchCity]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await axios.put(`${API_BASE_URL}/api/cities/${id}`, form);
      } else {
        await axios.post(`${API_BASE_URL}/api/cities`, form);
      }
      navigate('/city');
    } catch (error) {
      console.error('Error saving city:', error);
    }
  };

  const filteredStates = states.filter(
    (state) =>
      state.country === form.country || state.country?._id === form.country
  );

  return (
    <div className="add-state-page bg-light min-vh-100 p-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="page-title fw-bold">{id ? 'Edit City' : 'Add City'}</h4>
        <button
          className="btn custom-back-button"
          onClick={() => navigate('/city')}
        >
          <i className="bi bi-arrow-left me-1"></i> Back to City
        </button>
      </div>

      <div className="header-bar text-white p-2 rounded-top ">
        <strong>{id ? 'Update City Information' : 'City Creation Form'}</strong>
      </div>

      <div className="card rounded-0 rounded-bottom shadow-sm">
        <div className="card-body">
          <h6 className="mb-3 border-bottom pb-2 fw-bold">General Details</h6>
          <form onSubmit={handleSubmit}>
            <div className="row g-3 mb-3">
              <div className="col-md-6">
                <label className="form-label">City Name <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Enter City Name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">City Code <span className="text-danger">*</span></label>
                <input
                  type="text"
                  className="form-control"
                  name="code"
                  placeholder="Enter City Code"
                  value={form.code}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">Country <span className="text-danger">*</span></label>
                <select
                  className="form-select"
                  name="country"
                  value={form.country}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Country</option>
                  {countries.map((country) => (
                    <option key={country._id} value={country._id}>
                      {country.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">State <span className="text-danger">*</span></label>
                <select
                  className="form-select"
                  name="state"
                  value={form.state}
                  onChange={handleChange}
                  required
                  disabled={!form.country}
                >
                  <option value="">Select State</option>
                  {filteredStates.map((state) => (
                    <option key={state._id} value={state._id}>
                      {state.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-6">
                <label className="form-label">Remarks</label>
                <input
                  type="text"
                  className="form-control"
                  name="remarks"
                  placeholder="Enter Remarks"
                  value={form.remarks}
                  onChange={handleChange}
                />
              </div>

              <div className="col-12">
                <label className="form-label me-3">Status</label>
                <div className="form-check form-switch d-inline-block">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    name="status"
                    checked={form.status}
                    onChange={handleChange}
                    id="statusSwitch"
                  />
                  <label className="form-check-label" htmlFor="statusSwitch">
                    {form.status ? 'Active' : 'Inactive'}
                  </label>
                </div>
              </div>
            </div>

            <div className="text-end mt-4">
              <button
                type="button"
                className="btn btn-outline-danger me-2"
                onClick={() => navigate('/city')}
              >
                Cancel
              </button>
              <button type="submit" className="btn btn-success">
                {id ? 'Update' : 'Save'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCity;
